var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageNotSupported(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 101.4 101.4",
    style: {
      enableBackground: "new 0 0 101.4 101.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000113330209422828164280000011435853355227537802_);fill:#BEBEBE;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 101.4,
    height: 101.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062890077798710802400000007469940198505654190_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000062890077798710802400000007469940198505654190_)",
      fill: "#BEBEBE"
    },
    d: "M61.3,59.9l-6.1-6.1 l-2.7-2.7l0,0L44.4,43l0,0L43,41.6l0,0l-1.5-1.5l-1.4,1.4l2.3,2.3V57c0,1.1,0.9,2,2,2h13.2l2.3,2.3L61.3,59.9z M44.4,57V45.8 l6.8,6.8l-0.8,1l-2-2.7l-3,4h8.2l2,2H44.4z M47.2,43l-2-2h13.2c1.1,0,2,0.9,2,2v13.2l-2-2V43H47.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageNotSupported);
export default __webpack_public_path__ + "static/media/image_not_supported.80952b5b82f96d0870f9f0536dd6d428.svg";
export { ForwardRef as ReactComponent };